import { DashboardModule, Form } from '@domain-group/suit-theme'

import PortalDataInput from '../PortalDataInput'

const ListingStatus = () => (
  <DashboardModule boxProps={{ marginBottom: 'large', flexDirection: 'column' }} title="Status">
    <Form padding="large">
      <Form.Row>
        <PortalDataInput fieldKey="status" />

        <PortalDataInput marginTop={['large', 0]} fieldKey="underOffer" />
      </Form.Row>

      <Form.Row>
        <PortalDataInput marginTop="large" fieldKey="soldPrice" />

        <PortalDataInput marginTop="large" fieldKey="soldDate" />
      </Form.Row>

      <Form.Row>
        <PortalDataInput marginTop="large" fieldKey="hideSoldPrice" />
      </Form.Row>
    </Form>
  </DashboardModule>
)

export default ListingStatus
